<template>
  <div>
    <el-row>
      <el-button
        size="small"
        v-has="'add'"
        type="primary"
        icon="el-icon-plus"
        @click="handleOperate('create')"
        >新增</el-button
      >
    </el-row>
    <el-row :gutter="6">
      <el-col :span="24">
        <el-form :inline="true" label-suffix=":">
          <el-form-item label="市场名称" class="demo-form-inline headLabel">
            <el-input
              size="small"
              v-model="searchData.marketName"
              placeholder="请输入市场名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="国家" class="demo-form-inline">
            <el-select
              v-model="searchData.countryCode"
              size="small"
              placeholder="请选择国家"
              clearable
            >
              <el-option
                v-for="item in countryList"
                :key="item.countryCode"
                :label="item.countryName"
                :value="item.countryCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 新增设备类型筛选项 -->
          <el-form-item label="设备类型" class="demo-form-inline">
            <el-select
              v-model="searchData.deviceTypes"
              size="small"
              multiple
              placeholder="请选择设备类型"
              clearable
            >
              <el-option
                v-for="item in deviceTypeOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="handleSearch()"
            >查询</el-button
          >
        </el-form>
      </el-col>
    </el-row>
    <PageTable
      :columns="columns"
      :tableData="tableData"
      @page-change="handleChangePage"
    >
      <template slot-scope="{ row }" slot="deviceTypes">
        {{ getDeviceValues(row.deviceTypes) }}
      </template>
      <template slot-scope="{ row }" slot="marketMin">
        {{ row.marketMin }}——{{ row.marketMax }}
      </template>
      <template slot-scope="{ row }" slot="status">
        <span
          :style="row.status == 1 ? { color: '#67C23A' } : { color: 'red' }"
          >{{ row.status | typeDesc(enabledStatusList) }}</span
        >
      </template>
      <el-table-column label="操作" width="150px" align="center">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            v-has="'edit'"
            style="margin-right: 5px"
            @click="handleOperate('edit', row)"
            >编辑</el-button
          >
          <el-button v-has="'onOff'" type="text" @click="handleClickOnOff(row)">
            <span :class="row.status == 2 ? 'colorGreen' : 'colorRed'">{{
              row.status == 2 ? "启用" : "禁用"
            }}</span></el-button
          >
        </template>
      </el-table-column>
    </PageTable>
    <el-dialog
      center
      width="700px"
      :wrapperClosable="false"
      :title="operationType | operationTypeDesc"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <Detail
        :operationType="operationType"
        :detailData="detailData"
        :deviceList="countryList"
        :marketList="marketList"
        @submit="handleSubmit"
        @cancel="visible = false"
      />
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import PageTable from "@/components/PageTable.vue";
import {
  enabledStatusList,
  deviceTypeOptions,
} from "@/common/constant/constant.js";
import Detail from "./Detail.vue";
import {
  getMarketReleaseList,
  addMarketRelease,
  updateMarketRelease,
  getMarketList,
} from "./indexServe";
export default {
  name: "marketRelease",
  components: { PageTable, Detail },
  created() {
    this.$store.dispatch("updateDeviceList");
    this.$store.dispatch("updateCountryList");
    this.init();
  },
  data() {
    return {
      enabledStatusList,
      // 初始化设备类型选项
      deviceTypeOptions,
      searchData: {
        deviceTypes: [], // 初始化设备类型搜索条件
      },
      tableData: {
        list: [],
      },
      columns: [
        { key: "mgId", label: "ID" },
        { key: "countryName", label: "国家" },
        { key: "marketName", label: "市场名称" },
        { slot: "marketMin", label: "市场版本区间" },
        { key: "marketId", label: "市场ID" },
        { slot: "deviceTypes", label: "生效设备" },
        { key: "remarks", label: "备注" },
        { key: "createTime", label: "创建时间" },
        { key: "modifyTime", label: "修改时间" },
        { slot: "status", label: "状态", align: "center" },
      ],
      visible: false,
      operationType: "", // 记录当前操作模式新建-create、编辑-edit
      detailData: {},
      marketList: [],
    };
  },
  computed: {
    ...mapGetters(["deviceList", "countryList"]),
  },
  methods: {
    // 根据key字符串获取对应的value
    getDeviceValues(keyStr) {
      // 将字符串分割成key数组
      const keys = keyStr.split(",");

      // 遍历key数组，匹配对应的value
      const options = keys.map((key) => {
        const item = deviceTypeOptions.find((option) => option.key === key);
        return item ? item.value : ""; // 如果找不到对应key，返回空字符串
      });

      return options.join(",");
    },
    // 事件监听
    handleChangePage({ page, size }) {
      this.getTableList({ page, size });
    },
    async handleOperate(operationType, row) {
      this.visible = true;
      this.operationType = operationType;
      await this.getMarketList(); // 重新获取市场数据，以防有新建的市场
      if (operationType === "create") {
        this.detailData = {};
      } else {
        this.detailData = { ...row, deviceTypes: row.deviceTypes.split(",") };
      }
    },
    handleChangeStatus(row) {
      const status = row.status == 2 ? 1 : 2; // 将禁用状态改成启用，启用状态改成禁用
      updateMarketRelease({ ...row, status }).then((res) => {
        if (res && res.code === 0) {
          this.$message.success("操作成功");
          this.getTableList({
            page: this.tableData.page,
            size: this.tableData.size,
          }); // 删除成功后刷新列表
        }
      });
    },
    handleSearch() {
      this.getTableList({ page: 1 });
    },
    handleSubmit(formData) {
      const fcn =
        this.operationType === "edit" ? updateMarketRelease : addMarketRelease; // 编辑和新建分别调用不同接口
      if (formData.deviceTypes) {
        formData.deviceTypes = formData.deviceTypes.join(",");
      }
      fcn(formData).then((res) => {
        if (res && res.code == 0) {
          this.visible = false;
          this.getTableList({
            page: this.tableData.page,
            size: this.tableData.size,
          }); // 成功后刷新列表
          this.$message.success("操作成功");
        }
      });
    },
    handleClickOnOff(row) {
      const desc = `确定${row.status == 2 ? "启用" : "禁用"}吗？`;
      this.$confirm(desc, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleChangeStatus(row);
        })
        .catch(() => {});
    },
    // 后端请求
    // 获取列表
    async getTableList(params) {
      const obj = {
        page: 1,
        size: 10,
        ...this.searchData,
        ...params,
      };
      // 处理设备类型参数
      if (obj.deviceTypes && obj.deviceTypes.length == 0) {
        delete obj.deviceTypes;
      } else {
        obj.deviceTypes = obj.deviceTypes.join(",");
      }
      if (obj.channelId == "") {
        obj.channelId = undefined;
      }
      const res = await getMarketReleaseList(obj);
      if (res && res.code === 0) {
        // 下载时，不需要更新到table
        this.tableData = res.data;
      }
    },
    async getMarketList() {
      const res = await getMarketList();
      if (res && res.code === 0) {
        this.marketList = res.data.list;
      }
    },

    // 其他
    init() {
      this.getTableList();
      this.getMarketList();
    },
  },
};
</script>
